import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Flex, Notification, Text, NotificationProps, FlexProps } from '@coinflare/ui/core';
import { InfoIcon } from '@coinflare/ui/icons';

import { setCurrentUrl } from 'src/common/helpers';
import { APP_URLS } from 'src/setup/client/app-urls';

interface FeatureDisabledNotificationProps extends Pick<NotificationProps, 'type'>, FlexProps {
    preText?: string;
    text: string;
    isShown?: boolean;
}

export const FeatureDisabledNotification = ({
    preText,
    text,
    type = 'warning',
    isShown = false,
    ...rest
}: FeatureDisabledNotificationProps) => {
    const { t } = useTranslation();
    const { colors, isMobile } = useTheme();

    if (!isShown) {
        return null;
    }

    return (
        <Flex {...rest} width={'100%'}>
            <Notification
                width={'100%'}
                type={type}
                customContent={
                    <Flex
                        width={'100%'}
                        alignItems={'center'}
                        flexDirection={isMobile ? 'column' : 'row'}
                        gap={[1, 1, 0, 0]}
                    >
                        {isMobile ? (
                            <>
                                <Flex alignItems={'center'}>
                                    <InfoIcon />
                                    {preText && (
                                        <Text
                                            color={colors.text.primary}
                                            variant={'p2'}
                                            text={`${preText}:`}
                                            fontFamily={'Inter-Bold'}
                                            mr={1}
                                        />
                                    )}
                                </Flex>
                                <Text
                                    variant={'p2'}
                                    color={colors.text.primary}
                                    text={text}
                                    textAlign={isMobile ? 'center' : 'unset'}
                                />
                            </>
                        ) : (
                            <>
                                <InfoIcon />

                                <>
                                    {preText && (
                                        <Text
                                            variant={'p2'}
                                            color={colors.text.primary}
                                            text={`${preText}:`}
                                            fontFamily={'Inter-Bold'}
                                            mr={1}
                                        />
                                    )}
                                    <Text
                                        variant={'p2'}
                                        text={text}
                                        color={colors.text.primary}
                                        textAlign={isMobile ? 'center' : 'unset'}
                                    />
                                </>
                            </>
                        )}

                        <Text
                            ml={2}
                            variant={'p2'}
                            onClick={() => setCurrentUrl(APP_URLS.USER_VERIFICATION)}
                            fontFamily={'Inter-Medium'}
                            text={t('verify_now')}
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            color={colors.primary}
                        />
                    </Flex>
                }
            />
        </Flex>
    );
};
